import React, { useEffect } from 'react';
import Typography from '../../typography/typography';
import { MenuItem } from '@mui/material';
import Menu from '../../menu/menu';
import { aggregationFns } from '../aggregation-fns';
import { MRT_RowData } from 'material-react-table';

type aggregationType =
	| 'none'
	| 'count_empty'
	| 'count_full'
	| 'percentage_empty'
	| 'percentage_full'
	| 'average'
	| 'sum';

interface IAggregation {
	label: string;
	value: aggregationType;
}

const aggregations: IAggregation[] = [
	{
		label: 'Count Empty',
		value: 'count_empty'
	},
	{
		label: 'Count Full',
		value: 'count_full'
	},
	{
		label: 'Percentage Full',
		value: 'percentage_full'
	},
	{
		label: 'Percentage Empty',
		value: 'percentage_empty'
	},
	{
		label: 'Average',
		value: 'average'
	},
	{
		label: 'Sum',
		value: 'sum'
	},
	{
		label: 'None',
		value: 'none'
	}
];

const aggregationFnsLookup = {
	count_empty: aggregationFns.countEmpty,
	count_full: aggregationFns.countFull,
	percentage_empty: aggregationFns.percentageEmpty,
	percentage_full: aggregationFns.percentageFull,
	average: aggregationFns.average,
	sum: aggregationFns.sum,
	none: aggregationFns.none
};

interface IDefaultAggregation {
	data: MRT_RowData[];
	column: string;
	columnDef?: any;
}

const DefaultAggregation = ({
	data,
	column,
	// columnDef
}: IDefaultAggregation) => {
	const [selectedType, setSelectedType] =
		React.useState<aggregationType>('none');
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const [calculatedValue, setCalculatedValue] = React.useState<string | null>();
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const handleAggregationType = (val: aggregationType) => {
		setSelectedType(val);
		handleClose();
	};

	useEffect(() => {
		const func = aggregationFnsLookup[selectedType];
		setCalculatedValue(func(data, column));
	}, [selectedType, column, data]);

	return (
		<>
			<Typography
				onClick={handleClick}
				sx={{ cursor: 'pointer', width:"100%", height:"100%" }}
				type='s4'
				weight='normal'
				color={
					calculatedValue ? 'theme.secondary.1000' : 'theme.secondary.500'
				}>
				{calculatedValue || '+ Add Calculation'}
			</Typography>
			<Menu
				id='basic-menu'
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}>
				{aggregations?.map((aggr) => (
					<MenuItem
						key={aggr.value}
						selected={selectedType == aggr?.value}
						onClick={() => handleAggregationType(aggr?.value)}
						// disabled={
						// 	(!columnDef || columnDef?.type !== 'number') &&
						// 	(aggr.value === 'sum' || aggr.value === 'average')
						// }
						>
						<Typography color='theme.secondary.1000' type='s4'>
							{aggr?.label}
						</Typography>
					</MenuItem>
				))}
			</Menu>
		</>
	);
};

export { DefaultAggregation };
export default DefaultAggregation;
